import React from 'react';
import UserInfo from '../../../../../UserInfo';
import PropTypes from 'prop-types';

const Percentage = ({ value }) => {

    if ([null, undefined, "", "N/A"].includes(value)) {
        return value;
    }

    const roundedPercentage = `${parseFloat(value).toFixed(UserInfo.getInstance(UserInfo.getInstanceID()).weightPrecision)}%`;

    return (
        <span>
            {roundedPercentage}
        </span>
    );
};

Percentage.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired
};

Percentage.defaultProps = {};

export default Percentage;
